import { Modal } from '@/components/common/AppModal';
import { Button, Alert, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type GenerateApiKeyModalType = 'create' | 'regenerate';

type GenerateApiKeyModalProps = {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isGenerating?: boolean;
  type?: GenerateApiKeyModalType;
};

const GenerateApiKeyModal = ({
  show,
  onHide,
  onConfirm,
  isGenerating,
  type = 'create'
}: GenerateApiKeyModalProps) => {
  const isRegenerate = type === 'regenerate';

  const title = isRegenerate
    ? 'تأیید ساخت مجدد API Key'
    : 'تأیید ایجاد API Key';

  const alertMessage = isRegenerate
    ? 'با ساخت مجدد، API Key قبلی غیرفعال می‌شود و API Key جدید ایجاد می‌شود. API Key جدید فقط یک‌بار نمایش داده می‌شود، حتماً آن را ذخیره کنید.'
    : 'API Key فقط یک‌بار ساخته و نمایش داده می‌شه، حتماً ذخیره‌ش کن.';

  const confirmQuestion = isRegenerate
    ? 'آیا از ساخت مجدد API Key مطمئن هستید؟'
    : 'آیا از ایجاد API Key جدید مطمئن هستید؟';

  const confirmButtonText = 'بله، ایجاد کن';

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="mb-3 fs--1">
          <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
          <strong>توجه:</strong> {alertMessage}
        </Alert>
        <p className="mb-0">{confirmQuestion}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide}>
          انصراف
        </Button>
        <Button
          variant="falcon-primary"
          size="sm"
          onClick={onConfirm}
          disabled={isGenerating}
        >
          {isGenerating ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              در حال ایجاد...
            </>
          ) : (
            confirmButtonText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenerateApiKeyModal;
